import axios from "axios"
import { api, authenticatedApi } from "./client"
import { User } from "@/types/user"

export const askForPasswordReset = async (email: string): Promise<void> => {
  try {
    await api.post("/users/password", { email })
  } catch (error) {
    console.error("Error askForPasswordReset:", error)
    throw error
  }
}

export const resetForgottenPassword = async (
  code: string,
  password: string,
): Promise<number> => {
  try {
    const response = await api.patch("/users/password", { code, password })
    return response.status
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const status = error.response?.status
      if (status === 400 || status === 404) {
        return status
      }
    }
    console.error("Error resetForgottenPassword:", error)
    throw error
  }
}

export const login = async (
  email: string,
  password: string,
): Promise<string> => {
  const response = await api.post("/auth/login", {
    email,
    password,
  })

  if (!response.data || !response.data.key) {
    console.error("Unexpected response structure from login:", response.data)
  }

  return response.data.key
}

export const getUser = async (): Promise<User> => {
  try {
    const response = await authenticatedApi.get<User>("/auth/user/")
    return response.data
  } catch (error) {
    console.error("Error getting user:", error)
    throw error
  }
}

export const signupLink = async (email: string) => {
  try {
    await api.post("/users/code", {
      email,
    })
  } catch (error) {
    console.error("Error sending signup link:", error)
    throw error
  }
}

export const logout = async () => {
  try {
    await authenticatedApi.post("/auth/logout")
  } catch (error) {
    console.error("Error logging out:", error)
    throw error
  }
}

export const googleLoginViaToken = async (
  access_token: string,
): Promise<string> => {
  try {
    const response = await api.post("/auth/google/token/", {
      access_token,
    })

    if (!response.data || !response.data.key) {
      console.error(
        "Unexpected response structure from Google login:",
        response.data,
      )
    }

    return response.data.key
  } catch (error) {
    console.error("Error with Google login:", error)
    throw error
  }
}
